var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Modal from './components/templates/Modal/Modal';
import Initial from './components/organisms/Initial';
import { PUSH, readModalHistoryAtom, readWriteModalHistoryAtom, REPLACE, Tasks } from './stores';
import LoginEmail from './components/organisms/LoginEmail';
import FindEmailInitial from './components/organisms/FindEmailInitial';
import ChangePasswordInitial from './components/organisms/changePassword/ChangePasswordInitial';
import FindEmailDone from './components/organisms/FindEmailDone';
import LoginKakao from './components/organisms/LoginKakao';
import ChangePasswordAuth from './components/organisms/changePassword/ChangePasswordAuth';
import ChangePasswordEnter from './components/organisms/changePassword/ChangePasswordEnter';
import ChangePasswordDone from './components/organisms/changePassword/ChangePasswordDone';
import SignupEmail from './components/organisms/SignupEmail';
import SignupWelcome from './components/organisms/SignupWelcome';
import { useAtom, useAtomValue } from 'jotai';
import { useInitializeHideCloseButton, useInitializeNoBirthDate, useKakaoInit, useQueryStringParams, } from './businessLogics/hooks';
import { getBrandByLocation } from './businessLogics';
import { sendLog } from './logging';
import { KakaoScripts } from './logging/kakao/scripts';
import SignupKakao from './components/organisms/SignupKakao';
import ChangePhoneNumberEnterAndAuth from './components/organisms/changePhoneNumber/ChangePhoneNumberEnterAndAuth';
import ChangePhoneNumberReady from './components/organisms/changePhoneNumber/ChangePhoneNumberReady';
import ChangeEmailEnter from './components/organisms/changeEmail/ChangeEmailEnter';
import ChangeEmailAuth from './components/organisms/changeEmail/ChangeEmailAuth';
import ChangeEmailReady from './components/organisms/changeEmail/ChangeEmailReady';
import ChangePhoneNumberDone from './components/organisms/changePhoneNumber/ChangePhoneNumberDone';
import ChangeEmailDone from './components/organisms/changeEmail/ChangeEmailDone';
var Process = function (_a) {
    var _b;
    var isShow = _a.isShow, setIsShow = _a.setIsShow, CPLogger = _a.CPLogger, nextPage = _a.nextPage, designatedInitialTask = _a.designatedInitialTask, _c = _a.onlyEmail, onlyEmail = _c === void 0 ? false : _c, _d = _a.hideCloseFromClient, hideCloseFromClient = _d === void 0 ? false : _d, _e = _a.noBirthDateFromClient, noBirthDateFromClient = _e === void 0 ? false : _e, setIsAborted = _a.setIsAborted, initialTextProps = _a.initialTextProps;
    var _f = useAtom(readWriteModalHistoryAtom), task = _f[0], updateHistory = _f[1];
    var taskHistory = useAtomValue(readModalHistoryAtom);
    var outroProps = { setIsShow: setIsShow, nextPage: nextPage, onlyEmail: onlyEmail };
    var _g = useKakaoInit('https://t1.kakaocdn.net/kakao_js_sdk/2.0.1/kakao.min.js'), isLoading = _g[0], error = _g[1];
    var _h = useInitializeHideCloseButton(hideCloseFromClient), hideClose = _h[0], setHideClose = _h[1];
    var query = useQueryStringParams();
    useEffect(function () {
        if (query.get('login_v2_email')) {
            updateHistory({ action: PUSH, task: Tasks.LOGIN_EMAIL });
            setIsShow(true);
        }
    }, [query.get('login_v2_email')]);
    useEffect(function () {
        if (query.get('kakao_login_error')) {
            alert(decodeURIComponent(query.get('kakao_login_error') || '카카오 로그인 중 오류가 발생했습니다. 다시 시도해주세요.'));
            updateHistory({ action: PUSH, task: Tasks.INITIAL });
            setIsShow(true);
        }
    }, [query.get('kakao_login_error')]);
    useInitializeNoBirthDate(noBirthDateFromClient);
    useEffect(function () {
        if (!isLoading && !error) {
            if (!window.Kakao.isInitialized()) {
                window.Kakao.init('535068688f1a8bca1c21a9445ede0a89');
            }
        }
    }, [isLoading, error]);
    useEffect(function () {
        if (designatedInitialTask) {
            updateHistory({ action: REPLACE, task: designatedInitialTask });
        }
    }, [designatedInitialTask]);
    useEffect(function () {
        if (isShow && taskHistory.length === 1 && taskHistory[0] === Tasks.INITIAL) {
            sendLog("".concat(getBrandByLocation(), "_loginPopUp_view"), CPLogger);
        }
    }, [isShow, taskHistory]);
    var componentsMap = (_b = {},
        _b[Tasks.INITIAL] = _jsx(Initial, __assign({}, outroProps, { initialTextProps: initialTextProps, CPLogger: CPLogger })),
        _b[Tasks.SIGNUP_EMAIL] = _jsx(SignupEmail, __assign({}, outroProps, { CPLogger: CPLogger })),
        _b[Tasks.SIGNUP_KAKAO] = _jsx(SignupKakao, __assign({}, outroProps, { CPLogger: CPLogger })),
        _b[Tasks.SIGNUP_WELCOME] = _jsx(SignupWelcome, __assign({}, outroProps, { CPLogger: CPLogger })),
        _b[Tasks.LOGIN_EMAIL] = _jsx(LoginEmail, __assign({}, outroProps, { CPLogger: CPLogger })),
        _b[Tasks.LOGIN_KAKAO] = _jsx(LoginKakao, __assign({}, outroProps, { CPLogger: CPLogger })),
        _b[Tasks.FIND_EMAIL_INITIAL] = _jsx(FindEmailInitial, {}),
        _b[Tasks.FIND_EMAIL_DONE] = _jsx(FindEmailDone, { setIsShow: setIsShow }),
        _b[Tasks.CHANGE_PASSWORD_INITIAL] = _jsx(ChangePasswordInitial, {}),
        _b[Tasks.CHANGE_PASSWORD_AUTH] = _jsx(ChangePasswordAuth, {}),
        _b[Tasks.CHANGE_PASSWORD_ENTER] = _jsx(ChangePasswordEnter, {}),
        _b[Tasks.CHANGE_PASSWORD_DONE] = _jsx(ChangePasswordDone, { setIsShow: setIsShow }),
        _b[Tasks.CHANGE_PHONE_NUMBER_ENTER_AND_AUTH] = _jsx(ChangePhoneNumberEnterAndAuth, {}),
        _b[Tasks.CHANGE_PHONE_NUMBER_READY] = _jsx(ChangePhoneNumberReady, {}),
        _b[Tasks.CHANGE_PHONE_NUMBER_DONE] = _jsx(ChangePhoneNumberDone, { setIsShow: setIsShow }),
        _b[Tasks.CHANGE_EMAIL_ENTER] = _jsx(ChangeEmailEnter, {}),
        _b[Tasks.CHANGE_EMAIL_AUTH] = _jsx(ChangeEmailAuth, {}),
        _b[Tasks.CHANGE_EMAIL_READY] = _jsx(ChangeEmailReady, {}),
        _b[Tasks.CHANGE_EMAIL_DONE] = _jsx(ChangeEmailDone, { setIsShow: setIsShow }),
        _b);
    return (_jsx(_Fragment, { children: isShow && (_jsxs(_Fragment, { children: [_jsx(KakaoScripts, {}), _jsx(Modal, __assign({ isShow: isShow, setIsShow: setIsShow, setIsAborted: setIsAborted, CPLogger: CPLogger }, { children: componentsMap[task] }))] })) }));
};
export default Process;
//# sourceMappingURL=Process.js.map